import _ from 'lodash';

export const formatDecimal = (value?: number, suffix = ''): string => {
  return typeof value === 'number' ? value.toFixed(2).replace('.', ',') + suffix : '';
};

/** Prices, everywhere. Returns an empty string for a missing value rather than "0,00 €". */
export const formatEuro = (value?: number): string =>
  value?.toLocaleString('fi-FI', { style: 'currency', currency: 'EUR' }) ?? '';

export const generateChangeLog = <T extends object>(
  value: T,
  other: object,
  excludedFields: Array<keyof T> = []
): string => {
  const unfilteredChanges = _.differenceWith(_.toPairs(value), _.toPairs(other), _.isEqual);

  const changes =
    excludedFields.length > 0
      ? unfilteredChanges.filter(([key]) => !excludedFields.includes(key as keyof T))
      : unfilteredChanges;

  const formatValue = (val: unknown) => {
    if (Array.isArray(val)) {
      return (
        '\n' +
        val
          .map((item) => {
            if (typeof item === 'object' && item !== null) {
              return (
                '\t\t- ' +
                Object.entries(item)
                  .map(([k, v]) => `${k}: ${v}`)
                  .join(', ')
              );
            }
            return `\t• ${String(item)}`;
          })
          .join('\n')
      );
    }
    else if (typeof val === 'object' && val !== null) {
      return (
        '\n' +
        Object.entries(val)
          .map(([k, v]) => `\t\t- ${k}: ${v}`)
          .join('\n')
      );
    }
    else{
      return String(val);
    }
  };

  return changes.length > 0
    ? `\nChangelog:\n${changes
      .map(([key, value]) => `\t• ${key}: ${formatValue(value)}\n`)
      .join('')}`
    : '';
};
